export default "__VITE_ASSET__BYtdo1u7__"